import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { UserForm, UserFormType } from './UserForm'
import { getUserById, toggleUserLock, updateUser } from 'api/userApi'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'User Management',
    path: '/system/users'
  },
  {
    label: 'Edit User',
    isCurrentPage: true
  }
]

export const EditUser = () => {
  const { userId } = useParams()
  const { createToast } = useAppContext()
  const [user, setUser] = useState(null)
  const [formError, setFormError] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isToggling, setIsToggling] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const row = await getUserById(userId)
        setUser(row)
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleEdit = async (form) => {
    setIsSubmitting(true)

    try {
      const row = await updateUser(userId, {
        firstname: form.firstname,
        lastname: form.lastname,
        email: form.email,
        phone: form.phone,
        role: form.role
      })
      if (row) {
        setUser(row)
        createToast('success', 'User updated.')
      } else {
        createToast('error', 'Failed to update.')
      }
      setIsSubmitting(false)
    } catch (err) {
      if (err.response.status === 400) {
        setFormError(err.response.data)
      } else {
        createToast('error', 'Error', err.response.data)
      }
      setIsSubmitting(false)
    }
  }

  const handleToggleLock = async () => {
    setIsToggling(true)

    try {
      const row = await toggleUserLock(userId)
      setUser(row)
      createToast('success', 'User lock status updated')
      setIsToggling(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsToggling(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Edit User</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">User Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <UserForm
              type={UserFormType.Edit}
              onSubmit={handleEdit}
              isSubmitting={isSubmitting}
              initialForm={user}
              initialFormError={formError}
              isToggling={isToggling}
              onToggleLock={handleToggleLock}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
